<template>
  <div class="reply_cell container-fluid">
    <div class="row">
      <div class="col-xs-2" style="width: 39px; padding-left: 0;">
        <img src="" style="width: 100%;"/>
      </div>
      <div class="col-xs-10" style="width: calc( 100% - 39px ); padding-right: 0;">
        <div>{{reply.user.name}}<span class="comment_datetime">({{reply.created_datetime}})</span></div>
        <p><a>{{reply.reply_to.name}}</a>{{reply.message}}</p>
        <a style="display: block;" @click="isShowReplyTextDiv = true">回覆</a>
        <div v-show="isShowReplyTextDiv" class="reply_textarea_div">
          <!-- <div class="mdl-textfield mdl-js-textfield" style="width: 100%;">
            <div contenteditable="true" class="mdl-textfield__input reply_textarea">
              <a class="reply_to" contenteditable="false">{{reply.user.name}}</a>
            </div>
            <label class="mdl-textfield__label" for="reply_to_<?php echo $_reply->id; ?>"></label>
          </div> -->
          <md-field>
            <md-textarea v-model="replyMessage"></md-textarea>
          </md-field>
          <div class="row">
            <button class="mdl-button mdl-js-button mdl-button--raised mdl-button--accent reply_post_btn" style="float: right; margin-left: 10px;" :disabled="replyMessage.length === 0" @click="post_reply">發佈</button>
            <button class="mdl-button mdl-js-button mdl-button--raised" style="float: right;" @click="cancel_reply">取消</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    reply: Object
  },
  data () {
    return {
      isShowReplyTextDiv: false,
      courseId: this.$parent.courseId,
      weekId: this.$parent.weekId,
      activityId: this.$parent.activityId,
      videoId: this.$parent.videoId,
      id: this.reply.id,
      replyMessage: ''
    }
  },
  methods: {
    post_reply: function () {
      console.log(this.replyMessage)
      let fd = new FormData()
      fd.append('message', this.replyMessage)
      this.$store.dispatch('request', {
        method: 'post',
        route: `courses/${this.courseId}/weeks/${this.weekId}/activities/${this.activityId}/videos/${this.videoId}/comments/${this.id}/replies`,
        data: fd
      }).then(reply => {
        this.$parent.replies.push(reply)
        this.replyMessage = ''
      })
    },
    cancel_reply: function () {
      this.isShowReplyTextDiv = false
      this.replyMessage = ''
    }
  }
}
</script>
